module.exports = __webpack_public_path__ + "img/octopus-new-year.2a671660.svg";